import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/HISTORY`;

export const ROUTES = {
  ROOT: '/shipment/track/:shipmentId?',
};
